/**
 * True when a keyboard event's target is a text field, slider, contenteditable or open Radix menu
 * — surfaces whose own keys canvas shortcuts must not steal.
 */
export function isEditableEventTarget(target: EventTarget | null): boolean {
  const el = target instanceof HTMLElement ? target : null

  if (!el) return false

  return Boolean(
    el.closest(
      'input, textarea, [contenteditable="true"], [role="textbox"], [role="slider"], [data-radix-menu-content]'
    )
  )
}
